import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity, type PartialEntityData } from '@adornis/baseql/entities/adornisEntity.js';
import { Mitarbeiter } from '@chancenwerk/shared/master-data-management/users/entities/Mitarbeiter.js';
import { DateTime } from 'luxon';

/**
 * Entity to hold a value difference between two values.
 */
@Entity()
export class WorkTrackingValDiff extends AdornisEntity {
  static override _class = 'WorkTrackingValDiff';

  static override resolveID(entity: any): string {
    return A.getGloballyUniqueID();
  }

  constructor(doc: PartialEntityData<WorkTrackingValDiff>) {
    super(doc);
  }

  @Field(() => String)
  val: Maybe<string>;

  @Field(() => String)
  from: Maybe<string>;

  @Field(() => String)
  to: Maybe<string>;
}

/**
 * Entity to hold a change in a work tracking activity.
 */
@Entity()
export class WorkTrackingChange extends AdornisEntity {
  static override _class = 'WorkTrackingChange';

  static override resolveID(entity: any): string {
    return A.getGloballyUniqueID();
  }

  constructor(doc: PartialEntityData<WorkTrackingChange>) {
    super(doc);
  }

  /**
   * The user who made the change.
   */
  @DataLoadedField(() => Mitarbeiter, ({ fromID }) => fromID)
  from: Maybe<Mitarbeiter>;

  /**
   * The userID who made the change.
   */
  @Field(() => String)
  fromID: Maybe<string>;

  /**
   * Any note the user added to the change.
   */
  @Field(() => String)
  note: Maybe<string>;

  /**
   * The difference between the values.
   */
  @Field(() => [WorkTrackingValDiff])
  diff: Maybe<WorkTrackingValDiff[]>;

  /**
   * The date the change was made.
   */
  @Field(() => DateTime)
  date: Maybe<DateTime>;
}
